import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MetricType } from "@madmedical/medical";
import { DashboardWidgetsWrapper, Spinner } from "@madmedical/ui";
import { useCallback, useState } from "react";
import { InsulinDashboardWidget } from "../insulin/charts/InsulinDashboardWidget";
import DashboardWidget from "./DashboardWidget";
const metricTypes = [
    MetricType.BloodOxygen,
    MetricType.BloodPressure,
    MetricType.BloodSugar,
    MetricType.BodyMassIndex,
    MetricType.BodyTemperature,
    MetricType.BodyWeight,
    MetricType.DailySteps,
    MetricType.HeartRateVariability,
    MetricType.RestingHeartRate,
    MetricType.SleepTime,
];
const DashboardWidgets = ({ isInsulin }) => {
    const [loadingMetricTypes, setLoadingMetricTypes] = useState(metricTypes);
    const handleLoadingFinished = useCallback((metricType) => {
        setLoadingMetricTypes((prev) => prev.filter((mt) => mt != metricType));
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs(DashboardWidgetsWrapper, { children: [metricTypes.map((metricType) => (_jsx(DashboardWidget, { metricType: metricType, onLoadingFinished: handleLoadingFinished }, metricType))), isInsulin && _jsx(InsulinDashboardWidget, {})] }), !!loadingMetricTypes.length && _jsx(Spinner, {})] }));
};
export default DashboardWidgets;
